module.exports = __webpack_public_path__ + "img/jwgl-kbbd-bdsz.9d5c8127.png";